import React, { useState, useEffect } from 'react'
import Breadcrumbs from '../../components/Global/Breadcrumbs'
import FlujoChart from '../../components/charts/FlujoChart'
import {
    Container,
    Card,
    CardBody,
    Row,
    Col
} from 'reactstrap'

import ApiService from '../../data/services/ApiService'
import CurrencyFormat from 'react-currency-format'

const Index = () => {
    const [year, setYear] = useState(new Date().getFullYear())
    const [totales, setTotales] = useState({
        facturado: 0,
        porCobrar: 0,
        ticketPromedio: 0
    })
    const [invoicesCount, setInvoicesCount] = useState(0)
    const [chartSeries, setChartSeries] = useState({})
    const [categories, setCategories] = useState([])

    useEffect(() => {
        (async () => {
            await _loadGraph()
        })()

        window.analytics.page('Reportes')
        // eslint-disable-next-line
    }, [year])

    const _loadGraph = async () => {
        const fromDate = new Date(`${year.toString()}/01/01`)
        const toDate = new Date(`${year.toString()}/12/31`)
        const response = await ApiService.obtenerGraficaAnual({
            fromDate, toDate
        })

        const { count, series, categories: cats } = response.data
        const count_ = count || 0
        const facturadoTotal = (series?.facturado || []).reduce((acc, v) => acc + parseFloat(v || 0), 0)
        const porCobrarTotal = (series?.porCobrar || []).reduce((acc, v) => acc + parseFloat(v || 0), 0)

        setInvoicesCount(count_)
        setChartSeries(series || {})
        setCategories(cats || [])
        setTotales({
            facturado: facturadoTotal,
            porCobrar: porCobrarTotal,
            ticketPromedio: count_ > 0 ? facturadoTotal / count_ : 0
        })
    }

    const _changeYearInput = (e) => {
        setYear(e.target.value)
    }

    const _getYears = () => {
        const year = new Date().getFullYear()
        let years = []

        for (var i = year; i >= (year - 10); i--) {
            years.push(i)
        }

        return years.map((item, key) => {
            return (<option key={key} value={item}>{item}</option>)
        })
    }

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Reportes"
                        breadcrumbItem={`Estadísticas`}
                        parentLink={`/reportes`}
                    />

                    <Card>
                        <CardBody>
                                <select
                                    onChange={_changeYearInput}
                                    className="custom-select">
                                    { _getYears() }
                                </select>
                        </CardBody>
                    </Card>

                    <Card>
                        <CardBody>
                            <Row>
                                <Col sm={3} style={{ textAlign: "center" }}>
                                    <h1>{invoicesCount}</h1>
                                    <h5>Facturas</h5>
                                </Col>

                                <Col sm={3} style={{ textAlign: "center" }}>
                                    <h1>
                                        <CurrencyFormat
                                            value={totales.facturado}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="$"
                                            decimalScale={2}
                                        />
                                    </h1>
                                    <h5>Facturación Total</h5>
                                </Col>

                                <Col sm={3} style={{ textAlign: "center" }}>
                                    <h1>
                                        <CurrencyFormat
                                            value={totales.ticketPromedio}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="$"
                                            decimalScale={2}
                                        />
                                    </h1>
                                    <h5>Ticket Promedio</h5>
                                </Col>

                                <Col sm={3} style={{ textAlign: "center" }}>
                                    <h1>
                                        <CurrencyFormat
                                            value={totales.porCobrar}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="$"
                                            decimalScale={2}
                                        />
                                    </h1>
                                    <h5>Facturas por Cobrar</h5>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <Card>
                        <FlujoChart series={chartSeries} categories={categories} />
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Index
